<afoone-breadcrumb
  [breadcrumbItems]="[
    {
      label: 'WXRL.LIST_RULES',
    }
  ]"
  [hideBackButton]="true"
></afoone-breadcrumb>

<div *ngIf="wxrlUnauthorized" class="wxrl-unauthorized-message">
  <p-message severity="warn" [text]="'WXRL.NOT_AUTHORIZED' | translate"></p-message>
  <p-button
    [label]="'WXRL.GO_TO_HOME' | translate"
    icon="pi pi-home"
    (click)="goToHome()"
    styleClass="p-button-outlined"
  ></p-button>
</div>

<ng-container *ngIf="!wxrlUnauthorized">
<afoone-wxrl-rule-list-filters
  (search)="listRules($event)"
  (laboratorySelected)="onLaboratorySelected($event)"
  (accessDenied)="onWxrlUnauthorized()"
></afoone-wxrl-rule-list-filters>

<div *ngIf="canEditSelectedLab" style="margin-bottom: 1rem">
  <p-button
    [label]="'WXRL.CREATE.BUTTON' | translate"
    icon="pi pi-plus"
    (click)="onCreateNewRule()"
    [disabled]="loadingPermissions"
  ></p-button>
</div>
<p-table
  [value]="rules"
  styleClass="p-datatable-striped"
  sortMode="single"
  dataKey="ruleNr"
  selectionMode="multiple"
  [(selection)]="selectedRules"
  [compareSelectionBy]="'equals'"
  sortField="ruleNr"
  [sortOrder]="1"
    [paginator]="true"
    [rows]="rowsPerPage"
    [first]="tableFirst"
    [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {last} {{
    'LIST.OF' | translate
  }} {totalRecords} {{ 'LIST.RECORDS' | translate }} ({{
    selectedRules?.length || 0
  }} {{ 'LIST.SELECTED' | translate }})"
  [rowsPerPageOptions]="[10, 20, 30, 60, 80, 100]"
  (onPage)="onPageChange($event)"
  (onRowSelect)="onRowSelectHandler($event)"
  (onRowUnselect)="onRowUnselectHandler($event)"
>
  <ng-template pTemplate="header">
    <tr>
      <th id="rule-selection-checkbox" style="width: 4rem">
        <p-tableHeaderCheckbox />
      </th>
      <th style="width: 2rem" id="rule-selection"></th>
      <th style="width: 2rem" id="rule-context-menu"></th>
      <th pSortableColumn="subjectType" id="rule-subject-type">
        {{ "WXRL.RULE.TIPO" | translate }}
        <p-sortIcon field="subjectType"></p-sortIcon>
      </th>
      <th pSortableColumn="subjectID" id="rule-subject-id">
        {{ "WXRL.RULE.ID_SUBJECT" | translate }}
        <p-sortIcon field="subjectID"></p-sortIcon>
      </th>
      <th pSortableColumn="subjectName" id="rule-subject-name">
        {{ "WXRL.RULE.NOMBRE" | translate }}
        <p-sortIcon field="subjectName"></p-sortIcon>
      </th>
      <th pSortableColumn="ruleNr" id="rule-rule-nr">
        {{ "WXRL.RULE.ID_REGLA" | translate }}
        <p-sortIcon field="ruleNr"></p-sortIcon>
      </th>
      <th pSortableColumn="ruleName" id="rule-rule-name">
        {{ "WXRL.RULE.DESCRIPCION" | translate }}
        <p-sortIcon field="ruleNr"></p-sortIcon>
      </th>
      <th pSortableColumn="formula" id="rule-formula">
        {{ "WXRL.RULE.FORMULA" | translate }}
        <p-sortIcon field="formula"></p-sortIcon>
      </th>
      <th pSortableColumn="negRule" id="rule-neg-rule">
        {{ "WXRL.RULE.NEGADA" | translate }}
        <p-sortIcon field="negRule"></p-sortIcon>
      </th>
      <th pSortableColumn="countEval" id="rule-count-eval">
        {{ "WXRL.RULE.CONT_EVAL" | translate }}
        <p-sortIcon field="countEval"></p-sortIcon>
      </th>
      <th pSortableColumn="percentExec" id="rule-percent-exec">
        {{ "WXRL.RULE.EJECUTADAS" | translate }}
        <p-sortIcon field="percentExec"></p-sortIcon>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-record>
    <tr [pSelectableRow]="record" (dblclick)="onRowDoubleClick(record)">
      <td (click)="$event.stopPropagation()">
        <p-tableCheckbox [value]="record" />
      </td>
      <td>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-search"
          (click)="onRowSelect(record)"
          class="p-button-rounded p-button-text"
        ></button>
      </td>
      <td>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-ellipsis-v"
          (click)="onContextMenu($event, record)"
          class="p-button-rounded p-button-text"
        ></button>
      </td>
      <td>{{ record.subjectType }}</td>
      <td>{{ record.subjectID }}</td>
      <td>{{ record.subjectName }}</td>
      <td>{{ record.ruleNr }}</td>
      <td>{{ record.ruleName }}</td>
      <td>{{ record.formula }}</td>
      <td>
        {{ record.negRule | SNCheck }}
      </td>
      <td>{{ record.countEval }}</td>
      <td>{{ record.percentExec }} %</td>
    </tr>
  </ng-template>
</p-table>

<p-contextMenu
  #contextMenu
  [model]="contextMenuItems"
  [baseZIndex]="10000"
  [appendTo]="'body'"
></p-contextMenu>

<p-confirmDialog [appendTo]="'body'"></p-confirmDialog>

<!-- Diálogo de clonación de reglas -->
<p-dialog
  [(visible)]="showCloneDialog"
  [modal]="true"
  [style]="{ width: '600px', height: '60vh' }"
  [header]="'WXRL.CLONE.DIALOG_TITLE' | translate"
  [draggable]="false"
  [resizable]="true"
  (onHide)="closeCloneDialog()"
>
  <form [formGroup]="cloneForm" *ngIf="!loadingCloneData">
    <div class="p-fluid">
      <!-- ID Regla Origen -->
      <div class="field">
        <label for="sourceRuleNr">{{ 'WXRL.CLONE.SOURCE_RULE_ID' | translate }} *</label>
        <p-inputNumber
          id="sourceRuleNr"
          formControlName="sourceRuleNr"
          [showButtons]="true"
          [min]="1"
          [useGrouping]="false"
          (onInput)="onSourceRuleNrChange()"
          [style]="{ width: '100%' }"
        ></p-inputNumber>
        <small
          class="p-error"
          *ngIf="cloneForm.get('sourceRuleNr')?.invalid && cloneForm.get('sourceRuleNr')?.touched"
        >
          <span *ngIf="cloneForm.get('sourceRuleNr')?.errors?.['required']">
            {{ 'WXRL.CLONE.ERRORS.SOURCE_REQUIRED' | translate }}
          </span>
          <span *ngIf="cloneForm.get('sourceRuleNr')?.errors?.['ruleNotFound']">
            {{ 'WXRL.CLONE.ERRORS.SOURCE_NOT_FOUND' | translate }}
          </span>
        </small>
      </div>

      <!-- ID Nueva Regla -->
      <div class="field">
        <label for="newRuleNr">{{ 'WXRL.CLONE.NEW_RULE_ID' | translate }} *</label>
        <p-inputNumber
          id="newRuleNr"
          formControlName="newRuleNr"
          [showButtons]="true"
          [min]="1"
          [useGrouping]="false"
          [style]="{ width: '100%' }"
        ></p-inputNumber>
        <small
          class="p-error"
          *ngIf="cloneForm.get('newRuleNr')?.invalid && cloneForm.get('newRuleNr')?.touched"
        >
          <span *ngIf="cloneForm.get('newRuleNr')?.errors?.['required']">
            {{ 'WXRL.CLONE.ERRORS.NEW_REQUIRED' | translate }}
          </span>
          <span *ngIf="cloneForm.get('newRuleNr')?.errors?.['ruleExists']">
            {{ 'WXRL.CLONE.ERRORS.NEW_EXISTS' | translate }}
          </span>
        </small>
      </div>

      <!-- Tipo de Disparador -->
      <div class="field">
        <label for="triggerType">{{ 'WXRL.CLONE.TRIGGER_TYPE' | translate }}</label>
        <p-dropdown
          id="triggerType"
          formControlName="triggerType"
          [options]="triggerTypes"
          optionLabel="subjectType"
          dataKey="codSubjectType"
          [placeholder]="'WXRL.CLONE.TRIGGER_TYPE_PLACEHOLDER' | translate"
          [showClear]="true"
          (onChange)="onTriggerTypeChange()"
          [style]="{ width: '100%' }"
          [appendTo]="'body'"
        ></p-dropdown>
      </div>

      <!-- Elemento que dispara la regla -->
      <div class="field" *ngIf="cloneForm.get('triggerType')?.value">
        <label for="triggerElement">{{ 'WXRL.CLONE.TRIGGER_ELEMENT' | translate }} *</label>
        <p-dropdown
          id="triggerElement"
          formControlName="triggerElement"
          [options]="triggerElements"
          optionLabel="label"
          dataKey="value"
          [placeholder]="'WXRL.CLONE.TRIGGER_ELEMENT_PLACEHOLDER' | translate"
          [showClear]="true"
          [filter]="true"
          filterBy="label"
          [virtualScroll]="true"
          [virtualScrollItemSize]="38"
          [style]="{ width: '100%' }"
          [panelStyle]="{ 'max-width': '400px' }"
          [appendTo]="'body'"
        ></p-dropdown>
        <small
          class="p-error"
          *ngIf="cloneForm.get('triggerElement')?.invalid && cloneForm.get('triggerElement')?.touched"
        >
          <span *ngIf="cloneForm.get('triggerElement')?.errors?.['required']">
            {{ 'WXRL.CLONE.ERRORS.TRIGGER_ELEMENT_REQUIRED' | translate }}
          </span>
        </small>
      </div>
    </div>
  </form>

  <div *ngIf="loadingCloneData" class="p-d-flex p-ai-center p-jc-center" style="min-height: 200px">
    <p-progressBar mode="indeterminate" [style]="{ width: '100%' }"></p-progressBar>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      [label]="'CANCEL' | translate"
      icon="pi pi-times"
      (click)="closeCloneDialog()"
      [styleClass]="'p-button-text'"
    ></p-button>
    <p-button
      [label]="'WXRL.CLONE.CLONE_BUTTON' | translate"
      icon="pi pi-check"
      (click)="onCloneSubmit()"
      [disabled]="cloneForm.invalid || loadingCloneData"
    ></p-button>
  </ng-template>
</p-dialog>
</ng-container>
